import React from 'react';
import BannerAdUnit from '../AdUnit/Banner';
import { STUDIO_PRODUCTS_CATALOG_CARD_A_REAL_ESTATE_ID } from '../constants';

export interface Props {}

const StudioProductsCatalogCardA: React.FC<Props> = () => (
  <BannerAdUnit
    width="306px"
    height="314px"
    realEstateId={STUDIO_PRODUCTS_CATALOG_CARD_A_REAL_ESTATE_ID}
  />
);
StudioProductsCatalogCardA.displayName = 'StudioProductsCatalogCardA';

export default StudioProductsCatalogCardA;
